<template>
    <component :is="item.component" v-if="item.component && !isItemHidden" v-bind="item.props" />
    <div v-else-if="item.header && !isItemHidden" class="vsm--header" :class="item.class" v-bind="item.attributes">

        <div class="in-manager" v-if="managerInfo.CompanyId !== null">
            <div class="info-company-left-menu">
                <div class="header-right-layout-masters">
                    <img :src="require('@/assets/img/logo.png')" alt />
                    <div class="backMenu" @click="closeMenu">
                        <font-awesome-icon :icon="'arrow-left'"></font-awesome-icon>
                    </div>
                </div>
                <div class="logo-info-left-menu">
                    <div v-if="managerInfo.profile && managerInfo.profile.Logo !== null && managerInfo.profile.Logo">
                        <app-image v-if="managerInfo.profile.Logo[0]" :has="managerInfo.profile.CompanyId"
                            type="profileLogo"></app-image>
                    </div>
                    <img v-else :src="require('@/assets/img/company.jpg')" alt />
                </div>
            </div>
            <div class="info-company-text">
                <p v-if="managerInfo.profile">{{ managerInfo.profile.Name }}</p>
                <p v-if="managerInfo.profile"><span class="icon-mar"><font-awesome-icon icon="user-circle" /> </span>
                    <span>{{ managerInfo.profile.MainStaffFirstName }}</span>
                    <span>{{ managerInfo.profile.MainStaffLastName }}</span>
                </p>
            </div>
        </div>

        <div class="in-woker" v-if="workerInfo.UserId !== null">
            <div class="info-company-left-menu">
                <div class="header-right-layout-masters">
                    <img :src="require('@/assets/img/logo.png')" alt />
                    <div class="backMenu" @click="closeMenu">
                        <font-awesome-icon :icon="'arrow-left'"></font-awesome-icon>
                    </div>
                </div>
                <div class="logo-info-left-menu">
                    <div v-if="workerInfo.profile && workerInfo.profile.Photo !== null && workerInfo.profile.Photo">
                        <app-image v-if="workerInfo.profile.Photo[0]" :has="workerInfo.profile.UserId" type="logoWorker"></app-image>
                    </div>
                    <img v-else :src="require('@/assets/img/profile_01.png')" alt />
                </div>
            </div>
            <div class="info-company-text">
                <p v-if="workerInfo.profile"><span class="icon-mar"><font-awesome-icon icon="user-circle" /> </span>
                    <span>{{ workerInfo.profile.Nickname }}</span>
                </p>
            </div>
        </div>
    </div>
    <div v-else-if="!isItemHidden" class="vsm--item" :class="[{ 'vsm--item_open': show }, { 'menuNone': createProfile }]"
        v-on="disableHover && isCollapsed ? { click: mouseEnterEvent } : { mouseover: mouseEnterEvent }" @mouseout="mouseLeaveEvent">
        <sidebar-menu-link :tag="item.disabled || !itemLinkHref ? 'span' : (isRouterLink ? 'router-link' : 'a')" :href="itemLinkHref" :disabled="item.disabled"
            :class="itemLinkClass" v-bind="item.attributes" @click.native="clickEvent">
            <sidebar-menu-icon v-if="item.icon && !isMobileItem" v-bind:icons="item.icon" />
            <template v-if="(isCollapsed && !isFirstLevel) || !isCollapsed || isMobileItem">
                <sidebar-menu-badge v-if="item.badge" :badge="item.badge"
                    :style="[rtl ? (item.child ? { 'margin-left': '30px' } : '') : (item.child ? { 'margin-right': '30px' } : '')]" />
                <span class="vsm--title" @click="clearConditionSearch(item.href)">{{ item.title }}</span>
                <span v-if="(item.href === '/company/messager' || item.href === '/worker/messager')" class="float-right">
                    <span class="notification-icon" v-if="notification.length > 0">{{ notification.length }}</span>
                </span>
                <div v-if="item.child" class="vsm--arrow" :class="[{ 'vsm--arrow_open': show }, { 'vsm--arrow_slot': $slots['dropdown-icon'] }]">
                    <slot name="dropdown-icon" />
                </div>
            </template>
        </sidebar-menu-link>
        <template v-if="item.child">
            <template v-if="(isCollapsed && !isFirstLevel) || !isCollapsed">
                <transition name="expand" @enter="expandEnter" @afterEnter="expandAfterEnter" @beforeLeave="expandBeforeLeave">
                    <div v-if="show" class="vsm--dropdown">
                        <div class="vsm--list">
                            <sidebar-menu-item v-for="(subItem, index) in item.child" :key="index" :item="subItem" :level="level + 1" :show-child="showChild"
                                :rtl="rtl" :is-collapsed="isCollapsed">
                                <slot slot="dropdown-icon" name="dropdown-icon" />
                            </sidebar-menu-item>
                        </div>
                    </div>
                </transition>
            </template>
        </template>
    </div>
</template>

<script>
import { itemMixin, animationMixin } from './sidebar-mixin'
import SidebarMenuLink from './SidebarMenuLink.vue'
import SidebarMenuIcon from './SidebarMenuIcon.vue'
import SidebarMenuBadge from './SidebarMenuBadge.vue'
import { mapGetters } from "vuex";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import jquery from "jquery";
import AppImage from "@/app/components/app-image";

export default {
    name: 'SidebarMenuItem',
    components: {
        AppImage,
        SidebarMenuLink,
        SidebarMenuIcon,
        SidebarMenuBadge,
        FontAwesomeIcon
    },
    computed: {
        ...mapGetters({
            managerInfo: 'managerSession/managerInfo',
            workerInfo: 'workerSession/workerInfo',
        }),
        notification() {
            return this.$store.getters.notification
        }
    },
    data: () => ({
        reUrl: '',
        createProfile: false,
    }),
    created() {
    },
    mounted() {
        let url = window.location.href
        let protocol = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port
        this.reUrl = url.replace(protocol, "");
        if (this.reUrl === '/company/create-profile') {
            this.createProfile = true
        } else {
            this.createProfile = false
        }
    },
    mixins: [itemMixin, animationMixin],
    props: {
        item: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            default: 1
        },
        isCollapsed: {
            type: Boolean
        },
        isMobileItem: {
            type: Boolean,
            default: false
        },
        mobileItem: {
            type: Object,
            default: null
        },
        activeShow: {
            type: Object,
            default: null
        },
        showChild: {
            type: Boolean,
            default: false
        },
        showOneChild: {
            type: Boolean,
            default: false
        },
        rtl: {
            type: Boolean,
            default: false
        },
        disableHover: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeMenu() {
            jquery('.v-sidebar-menu').addClass("close-menu");

        },
        clearConditionSearch(href) {
            if (href !== '/company/search-worker') {
                localStorage.removeItem('searchConditionWorker');
            }
            if (href !== '/worker/search') {
                localStorage.removeItem('searchConditionProject');
            }
        }
    }
}
</script>

<style scoped lang="scss">
.info-company-left-menu {
    height: 60px;
}

.backMenu {
    float: right;
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 100%;
    vertical-align: middle;
    background: #fff;
    display: none;

    svg {
        font-size: 22px;
        color: #999999 !important;
        float: left;
        margin-top: 15px;
        margin-left: 15px;
    }
}

.notification-icon {
    width: 25px;
    height: 25px;
    margin-left: 20px;
    padding-top: 1px;
    color: #ffffff;
    font-size: 13.6px;
    text-align: center;
    background: #E94F4D;
    border-radius: 50px;
    line-height: 20px;
}

.float-right {
    float: right !important;
}

.menuNone {
    display: none !important;
}
</style>
